import { Topic } from '$services/tracking/Topic';
import type { Feature, FeatureStatus } from '@otto-ec/tracking-bct';
import TrackingService, { ActionName, type TrackingFeature } from '$services/tracking/TrackingService';
import { logger } from '../../logger';

export default class PointsProgressTrackingService {

	private trackingService: TrackingService;

	constructor() {
		this.trackingService = new TrackingService();
	}

	async sendProgressBarMiniActionTracking() {
		const featureId = { featureId: 'UpPoints_ProgressBar' };
		await this.trackingService.submitMiniAction([featureId]);
		logger.tracking(Topic.SubmitMiniAction, featureId);
	}

	async sendPointsProgressFeatureTracking(
		topic: Topic,
		status: string,
		nextPointsThreshold: string,
		container: Element,
		actionName: ActionName | null = null
	) {
		const trackingFeatures: TrackingFeature[] = [
			{
				id: 'UpPoints_ProgressBar',
				name: 'UpPoints_ProgressBar',
				status: status,
				labels: {
					...this.getAggregationFeatureLabels(container),
					up_NextPointsThreshold: nextPointsThreshold
				},
				position: this.getFeatureOrder(container)
			}
		];

		const features: Feature[] = this.toTrackingBCTFeature(trackingFeatures);

		await this.trackingService.submitTracking(topic, features, actionName);
	}

	async sendPointsProgressClickFeatureTracking(
		status: string,
		nextPointsThreshold: string,
		container: Element
	) {
		await this.sendPointsProgressFeatureTracking(
			Topic.AddActionToEvent,
			status,
			nextPointsThreshold,
			container,
			ActionName.CLICK
		);
	}

	private toTrackingBCTFeature(trackingFeatures: {
		id: string,
		name: string,
		status: string,
		parentId?: string,
		labels?: Record<string, string[]>
	}[]): Feature[] {
		return trackingFeatures.map((feature) => {
			return { ...feature, status: feature.status as FeatureStatus };
		});
	}

	private getAggregationFeatureLabels = (container: Element) => {
		const aggregationFeatureLabels = container.parentElement?.parentElement?.parentElement?.getAttribute('data-feature-tracking-labels');

		if (!aggregationFeatureLabels) {
			return {};
		}

		return JSON.parse(aggregationFeatureLabels);
	};

	private getFeatureOrder = (container: Element) => {
		const dataFeatureOrder = container.parentElement?.parentElement?.parentElement?.getAttribute('data-feature-order');
		if (!dataFeatureOrder) {
			return 1;
		}
		return parseInt(dataFeatureOrder, 10);
	};
}

